import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { AppCardList } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { useGetAllReferralsQuery } from '@/modules/Sites';

interface Props {
  siteId: string;
  currentPage: number;
  referralsListItems: BaseQueryParams<typeof useGetAllReferralsQuery>['data']['items'];
  referralsListTotalItems: BaseQueryParams<typeof useGetAllReferralsQuery>['data']['meta']['totalItems'];
  referralsListItemsPerPage: BaseQueryParams<typeof useGetAllReferralsQuery>['data']['meta']['itemsPerPage'];
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const ReferralsListView: FC<Props> = ({
  siteId,
  currentPage,
  referralsListItems,
  referralsListTotalItems,
  referralsListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  const referralId = useParams()['*'];

  return (
    <AppCardList
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: referralsListTotalItems,
        pageSize: referralsListItemsPerPage,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page)
      }}
      selectedKey={ referralId }
      rowKey="id"
      titleKey="name"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        xxl: 3
      }}
      navigateTo={ ({ id }) => ({ to: AppRoutes.ReferralsById.replace(':siteId', siteId).replace(':referralId', id) }) }
      list={ referralsListItems }
    />
  );
};
